export default __webpack_public_path__ + "static/media/k.2398303a.png";